var brandColor1 = '#0F363C'
var brandColor2 = '#0F363C'
var brandTextColor = '#0F363C'

var personalizedColors = {
  darkGreenBackground: '#0F363C',
  whiteText: '#FFFFFF',
  entryPointBackground: brandColor1,
  lighterBackground: '#ecedf1',
  primaryButtonBackground: '#1976d2',
  primaryButtonColor: '#FFFFFF',
  secondaryButtonBackground: '#6e7180',
  secondaryButtonColor: '#FFFFFF',

  white: '#FFFFFF',
  green: '#1de9b6',
  darkGreen: '#0F363C'
}

var brandMessageBubbleColors = function (bgColor, textColor) {
  return {
    Bubble: {
      background: bgColor,
      color: textColor
    },
    Avatar: {
      background: bgColor,
      color: textColor
    },
    Header: {
      color: textColor
    }
  }
}

const brandedColors = {
  Chat: {
    MessageListItem: {
      FromOthers: brandMessageBubbleColors(
        personalizedColors.white,
        personalizedColors.darkGreen
      ),
      FromMe: brandMessageBubbleColors(
        personalizedColors.darkGreen,
        personalizedColors.white
      )
    },
    MessageInput: {
      Container: {
        background: personalizedColors.green,
        Button: {
          background: brandColor1,
          color: personalizedColors.whiteText
        }
      }
    }
    // MessageCanvasTray: {
    //   Container: {
    //     background: personalizedColors.darkGreenBackground,
    //     color: personalizedColors.whiteText
    //   }
    // },
  },

  MainHeader: {
    Container: {
      background: personalizedColors.darkGreenBackground,
      color: personalizedColors.whiteText
    },
    Logo: {
      fill: brandColor1
    }
  },

  EntryPoint: {
    Container: {
      background: personalizedColors.entryPointBackground,
      color: personalizedColors.whiteText
    }
  },

  PreEngagementCanvas: {
    Container: {
      background: personalizedColors.lighterBackground
    },

    Form: {
      SubmitButton: {
        background: personalizedColors.primaryButtonBackground,
        color: personalizedColors.whiteText
      }
    }
  },
}

export default brandedColors
